/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-customer-service': {
    width: 19,
    height: 21,
    viewBox: '0 0 19 21',
    data: '<path pid="0" d="M8.444.008C4.27.008.752 2.9-.38 6.852c-1.013.609-1.604 1.785-1.604 3.158 0 1.995 1.214 3.611 3.208 3.611a.8.8 0 00.803-.802V7.202c0-.368-.263-.658-.602-.751 1.17-2.875 3.874-4.89 7.02-4.89 3.144 0 5.848 2.015 7.02 4.89-.34.093-.602.383-.602.751v5.617c0 .443.358.802.802.802.186 0 .354-.023.526-.05-.26 1.497-.888 2.612-1.529 3.384a5.891 5.891 0 01-1.128 1.053c-.159.111-.284.18-.376.226l-.101.05h-1.504c-.289-.838-1.207-1.454-2.307-1.454-1.329 0-2.406.898-2.406 2.005 0 1.108 1.077 2.006 2.406 2.006 1.099 0 2.018-.617 2.307-1.454h1.58c.27 0 .34-.072.501-.15.161-.08.351-.186.552-.326.505-.356.96-.778 1.354-1.254.845-1.018 1.633-2.531 1.83-4.563.945-.628 1.504-1.758 1.504-3.084 0-1.374-.592-2.548-1.604-3.158C16.137 2.9 12.617.008 8.444.008z" _fill="#fff"/>'
  }
})
